import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

function resetPasswordFailure(draft: Draft<IAuthData>) {
  draft.resetPassword.config.isLoading = false;
}

export default resetPasswordFailure;
